import { SetError } from "../features/ErrorDialog";
import languageService from "./languageService";





export class FetchService {

    public async fetch(url: RequestInfo | URL, init?: RequestInit | undefined): Promise<Response | undefined> {

        try {
            const response = await fetch(url, init);
            if (response) {
                if (200 <= response.status && response.status < 300) {
                    return response;
                }
                switch (response.status) {
                    case 500: {
                        const data = await response.json();

                        if (data["Message"]) {
                            SetError({ header: languageService.getText("error"), message: data["Message"] });
                        }
                        else {
                            SetError({ header: languageService.getText("error"), message: languageService.getText("servererror") });
                        }

                        return undefined;
                        break;
                    }

                    case 404: {
                        SetError({ header: languageService.getText("error"), message: "404 not found" });
                        return undefined;
                        break;
                    }

                    case 401: {
                        SetError({ header: languageService.getText("error"), message: "401 not allowed" });
                        return undefined;
                        break;
                    }

                    default: {
                        const data = await response.json();
                        if (data) {
                            SetError({ header: languageService.getText("error"), message: data });
                        }
                        else{
                            SetError({ header: languageService.getText("error"), message: languageService.getText("servererror") + "\r\n" + "Code " + response.status });
                        }
                        return undefined;
                        break;
                    }
                }
                return undefined;
            }
        }
        catch (err) {
            SetError({ header: " ", message: err?.toString() || "Unknown error" });
        }

        return undefined;
    }



}
const fetchService = new FetchService();
export default fetchService;